// extracted by mini-css-extract-plugin
export default {"scrim":"Sheet_scrim__vBTwo","sheetFade":"Sheet_sheetFade__30yjb","panel":"Sheet_panel__+BJu0","sheetUp":"Sheet_sheetUp__wv0e8","grabber":"Sheet_grabber__OLeOE"};